import PixQRCode from '../components/PixQRCode';
import '../css/presentes.css';
import '../css/components.css';

const PresenteViaPix = () => {
  return (
    <div className="pix-page" style={{ textAlign: 'center', padding: '50px' }}>
      <h1>Presente via PIX</h1>
      <p>Escaneie o QR Code abaixo e escolha o valor que deseja enviar 🎁</p>
      <PixQRCode />
    </div>
  );
};

export default PresenteViaPix;